import {OperaStatus} from 'front-onceforall-core';
import {Link} from 'react-router-dom';

import {ACTRADIS_MASTER_PLATFORM, status} from '../../../utils/constant';
import {interventionPropTypes} from '../../../utils/propTypes';
import authenticationService from '../../../services/authentication/AuthenticationService';
import config from '../../../../config';

import ClonedInvitationTooltip from '../../ClonedInvitationTooltip';

function ProjectTreeRowOrganisationName(props) {
  const {intervention} = props;
  const isPendingOrRejected = [status.REJECTED, status.PENDING].includes(intervention.status);

  const getOrganisationName = () => {
    if (authenticationService.roles().isBackOffice() && intervention.organisation.organisationId) {
      return <a
        href={`${config.backOfficeUrl}/organisations/${intervention.organisation.organisationId}/documents`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span
          data-id="fullName"
          className="clickable bo"
        >{intervention.organisation.fullName}</span>
      </a>;
    }

    const fullName = <span data-id="fullName">{intervention.organisation.fullName}</span>;

    function getOrganisationLink(prefix) {
      return <Link to={`/${prefix}/${intervention.organisation.organisationId}/projects`}>
        {fullName}
      </Link>;
    }

    // @TODO: need to update the way organisation link is displayed in project tree for each role
    if (!authenticationService.roles().isExplorer() && !isPendingOrRejected && props.myIntervention.depth - 1 === intervention.depth &&
    props.myIntervention.interventionPath && props.myIntervention.interventionPath.startsWith(intervention.interventionPath)) {
      return getOrganisationLink('client');
    }

    if (!authenticationService.roles().isExplorer() && !isPendingOrRejected && props.myIntervention.depth + 1 === intervention.depth &&
    intervention.interventionPath && intervention.interventionPath.startsWith(props.myIntervention.interventionPath)) {
      return getOrganisationLink('subcontractor');
    }

    return fullName;
  };

  const {registrationNumber} = intervention.organisation;
  return (
    <div
      data-id="organisation-data-name"
      className="flex-container"
    >
      <div className="d-flex flex-column">
        <strong>{getOrganisationName()}</strong>
        {registrationNumber && <span data-id="registrationNumber">{registrationNumber}</span>}
      </div>
      <ClonedInvitationTooltip invitation={intervention?.invitation}/>
      <OperaStatus
        organisation={intervention.organisation}
        small
        masterPlatformToShow={ACTRADIS_MASTER_PLATFORM}
      />
    </div>
  );
}

ProjectTreeRowOrganisationName.propTypes = {
  intervention: interventionPropTypes().isRequired,
  myIntervention: interventionPropTypes().isRequired
};

export default ProjectTreeRowOrganisationName;
